var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1001.888,
    height: 452.169,
    viewBox: "0 0 1001.888 452.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M4073.5,3487.075l39.825-26,18.675-31,8.5-39.325,13.825-39L4174,3323.075l26.075-27.25,33-14.325,58.5,4.825,56.5-3.575,28.525-14.5,25.65-25.675,13.325-32.25,11-29.5,11.175-39,8-35.325,25.825-38.175,48-25,30-7.5h36.5l31.675,7.5,31.5,17.5,21,25.175,11.825,26,6.675,32.25,5.325,74.5-3.325,38.5-2,40.825,2,26,7.25,25.175,12.5,26.325,19.825,23.5,23.425,18.675,24.325,13,29.5,7H4873.5l37.825-23.25L4928,3381.825l10.5-33.575,11.5-35.675,4.5-36.5,4.575-35.075,16.175-30.5,32-29.675L5035.075,3168l40-3.175",
    transform: "translate(-4073.227 -3035.325)",
    fill: "none",
    stroke: "#b9b9b9",
    strokeWidth: 1,
    strokeDasharray: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.93d526ec444b40569dfe8a2126348bd2.svg";
export { ForwardRef as ReactComponent };